import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { PageTransition } from "@/components/PageTransition";

const Privacy = () => {
  const navigate = useNavigate();

  return (
    <PageTransition>
      <div className="min-h-screen bg-background">
        <header className="sticky top-0 z-40 bg-background/80 backdrop-blur-lg border-b border-border/50 px-4 py-3">
          <div className="flex items-center gap-3 max-w-3xl mx-auto">
            <button onClick={() => navigate(-1)} className="p-2 -ml-2 rounded-full hover:bg-muted transition-colors">
              <ArrowLeft className="w-5 h-5 text-foreground" />
            </button>
            <h1 className="text-lg font-bold text-foreground">Privacy Policy</h1>
          </div>
        </header>
        <main className="max-w-3xl mx-auto px-6 py-10 space-y-6">
          <h2 className="text-2xl font-bold text-foreground">Informativa sulla Privacy</h2>
          <p className="text-sm text-muted-foreground">Ultimo aggiornamento: {new Date().toLocaleDateString("it-IT")}</p>

          <section className="space-y-3">
            <h3 className="text-lg font-semibold text-foreground">1. Titolare del trattamento</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Il titolare del trattamento dei dati personali è Tecly. Per qualsiasi domanda relativa alla privacy, puoi contattarci all'indirizzo email: info@tecly.it
            </p>
          </section>

          <section className="space-y-3">
            <h3 className="text-lg font-semibold text-foreground">2. Dati raccolti</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Raccogliamo i seguenti dati personali: nome, cognome, indirizzo email, numero di telefono (opzionale), dati di navigazione e preferenze dell'utente. I dati vengono raccolti tramite la registrazione al servizio e l'utilizzo dell'applicazione.
            </p>
          </section>

          <section className="space-y-3">
            <h3 className="text-lg font-semibold text-foreground">3. Finalità del trattamento</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              I dati personali vengono trattati per: fornitura del servizio, gestione dell'account utente, invio di comunicazioni relative al servizio, miglioramento dell'esperienza utente e adempimento di obblighi legali.
            </p>
          </section>

          <section className="space-y-3">
            <h3 className="text-lg font-semibold text-foreground">4. Base giuridica</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Il trattamento dei dati è basato sul consenso dell'utente, sull'esecuzione di un contratto e su obblighi legali ai sensi del GDPR (Regolamento UE 2016/679).
            </p>
          </section>

          <section className="space-y-3">
            <h3 className="text-lg font-semibold text-foreground">5. Diritti dell'utente</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              Hai il diritto di accedere, rettificare, cancellare i tuoi dati personali, limitare il trattamento, opporti al trattamento e richiedere la portabilità dei dati. Per esercitare i tuoi diritti, contattaci all'indirizzo info@tecly.it.
            </p>
          </section>

          <section className="space-y-3">
            <h3 className="text-lg font-semibold text-foreground">6. Conservazione dei dati</h3>
            <p className="text-sm text-muted-foreground leading-relaxed">
              I dati personali vengono conservati per il tempo necessario alle finalità per cui sono stati raccolti, e comunque non oltre i termini previsti dalla legge.
            </p>
          </section>
        </main>
      </div>
    </PageTransition>
  );
};

export default Privacy;
